module.exports = __webpack_public_path__ + "static/media/Tuvalu.96f71ed8.png";